<template>
    <el-dialog
        :visible.sync="dialogVisible"
        title="绑定客户"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="950px"
        append-to-body
        :before-close="handleClose">
        <div class="content-wrap pr20 mt20">
            <el-form ref="form" :model="formItem" :rules="rules" label-width="100px">
                <el-form-item label="绑定客户："  prop="customer_id">
                    <ESelect
                        v-model="formItem.customer_id"
                        clearable
                        collapse-tags
                        filterable
                        remote
                        reserve-keyword
                        placeholder="请选择绑定客户"
                        :remote-method="remoteSearchCustomer"
                        :loading="searchCustomerLoading"
                        style="width:450px">
                        <el-option
                            v-for="item in customerList"
                            :key="item.customer_id || item.id"
                            :label="item.company_name || item.name"
                            :value="item.customer_id || item.id">{{item.customer_name || item.name}}
                        </el-option>
                    </ESelect>
                </el-form-item>
                <el-form-item label="选择产品：">
                    <el-input v-model.trim="formItem.search" clearable placeholder="请输入完整推广ID或包名选择产品，多个产品可用英文逗号分隔“,”" maxlength="500" show-word-limit class="word-limit-input" style="width:450px"></el-input>
                    <el-button type="primary" @click="getBindAPP" class="ml20" :disabled="formItem.search.length<=0" :loading="searchAppLoading">确认</el-button>
                </el-form-item>
                <el-form-item label="已选产品："  prop="app_list">
                    <div class="app-list mt6 pl16">
                        <div class="app-item relative ellipsis" v-for="item in checkedAppList" :key="item.plat_id+item.subitem_id">
                            <p class="ellipsis" :title="item.subproject_name">【{{item.plat_name}}】{{item.subproject_name||'--'}}</p>
                            <p class="ellipsis pl6" :title="item.subproject_id">{{item.subproject_id||'--'}}</p>
                            <p class="ellipsis pl6" :title="item.subproject_content">{{item.subproject_content||'--'}}</p>
                            <div class="close-btn" @click="removeApp(item)" title="删除">X</div>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20" v-matomo="{behaviorCategory: '客户产品管理',name: '绑定产品(取消)' }">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20" v-matomo="{behaviorCategory: '客户产品管理',name: '绑定产品(提交)' }">保存</el-button>
        </div>


        <AppResultModal ref="appResultModal" :data-list="appResultList" @confirm="confirmSubmit"></AppResultModal>


    </el-dialog>
</template>

<script>
    import AppResultModal from './appResultModal';
    import API from '@/api/baseInfo/customerAppV2.js';
    import matomoFun from "@/utils/matomo.js";
    import { errAuthModal } from './index'

    export default {
        name: "BatchBindModal",
        components:{
            AppResultModal,
        },
        props:{
            customerData:Object,
            appList:Array,
        },
        data(){
            let _this = this;
            let validateApp =  (rule, value, callback) => {
                if(_this.checkedAppList.length<=0){
                    return callback(new Error('请选择需要绑定的产品'));
                }
                callback();
            };
            return {
                dialogVisible:false,
                formItem:{
                    customer_id:'',
                    search:'',
                },
                rules:{
                    customer_id:[
                        { required: true, message: '请选择绑定客户', trigger: 'change' },
                    ],
                    app_list:[
                        { validator: validateApp, trigger: 'blur' }
                    ],
                },
                submitLoading:false,
                searchCustomerLoading:false,
                customerList:[],
                searchAppLoading:false,
                checkedAppList:[],

                appResultList:[],
            }
        },
        methods:{
            handleClose(){
                matomoFun.trackEvent('客户产品管理', '点击', '绑定产品(取消)');
                this.resetForm();
                this.dialogVisible = false;
            },
            showModal(){
                this.dialogVisible = true;
                this.$nextTick(()=>{
                    if(this.customerData.customer_id){
                        // 选中具体客户-显示客户、产品空
                        this.customerList = [{
                            customer_id:this.customerData.customer_id,
                            company_name:this.customerData.company_name,
                        }];
                        this.formItem.customer_id = this.customerData.customer_id;
                        this.checkedAppList = [];
                    }else{
                        // 选中全部客户
                        if(this.appList.length>0){
                            // 选中了产品-客户空、显示产品
                            this.formItem.customer_id = '';
                            this.customerList = [];
                            let appList = this.appList||[];
                            console.log('appList',appList, this.checkedAppList);
                            appList.forEach(app=>{
                                let appItem = this.checkedAppList.find(item=>item.plat_id==app.plat_id&&item.subitem_id===app.subitem_id);
                               if(!appItem){
                                    this.checkedAppList.push({...app});
                                }
                            });
                            // this.checkedAppList = appList.map(item=>item);
                        }else{
                            // 未选产品-客户空、产品空
                            this.formItem.customer_id = [];
                            this.customerList = [];
                            this.checkedAppList = [];
                        }
                    }
                })
            },
            handleSubmit(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.submitLoading = true;
                        API.bindAppSave({
                            is_auth_plat_id_id:this.checkedAppList.map(item=>`${item.is_auth}-${item.plat_id}-${item.id}`),
                            customer_id:this.formItem.customer_id,
                        }).then(res=>{
                            console.log('bindAppSave',res);
                            let resData = res.data||[];

                            if(resData.length<=0){
                                this.$message.success(res.info||'操作成功');
                                this.submitLoading = false;
                                this.hideModal();
                            }else{
                                this.appResultList = resData;
                                this.$refs.appResultModal.showModal();
                            }

                            this.submitLoading = false;
                        },err=>{
                            if(err.data?.error_list) {
                                errAuthModal({
                                    props: {
                                        list: err.data?.error_list
                                    }
                                });
                                this.submitLoading = false;
                                return;
                            }
                            console.log('bindAppSave err',err);
                            this.submitLoading = false;
                            this.$message.error(err.info||'操作失败');
                        })
                    } else {
                        return false;
                    }
                });
            },
            confirmSubmit(val){
                this.submitLoading = true;
                API.bindAppSave({
                    is_auth_plat_id_id:this.checkedAppList.map(item=>`${item.is_auth}-${item.plat_id}-${item.id}`),
                    customer_id:this.formItem.customer_id,
                    confirm:val,
                }).then(res=>{
                    console.log('bindAppSave',res);
                    this.$message.success(res.info||'操作成功');
                    this.submitLoading = false;
                    this.hideModal();
                },err=>{
                    console.log('bindAppSave err',err);
                    this.submitLoading = false;
                    this.$message.error(err.info||'操作失败');
                })
            },
            hideModal(){
                console.log('hideModal');
                this.handleClose();
                this.$emit('close');
            },
            resetForm(){
                this.formItem.search = '';
                this.formItem.customer_id = '';
                this.customerList = [];
                this.checkedAppList = [];
                this.appResultList = [];
                this.submitLoading = false;
                // this.$refs.form.resetField();
            },
            removeApp(item){
                console.log('removeApp',item);
                let index = this.checkedAppList.findIndex(inner=>inner.plat_id==item.plat_id&&inner.subitem_id==item.subitem_id);
                this.checkedAppList.splice(index,1);
            },
            remoteSearchCustomer(query){
                API.getCompanySelector({
                    search:query,
                }).then(res=>{
                    console.log('getCompanySelector',res);
                    let resData =(res.data?.list ? res.data.list : res.data)||[];
                    this.searchCustomerLoading = false;
                    this.customerList = resData;
                },err=>{
                    console.log('getCompanySelector err',err);
                    this.$message.error(err.info||'请求失败');
                    this.searchCustomerLoading = false;
                    this.customerList = [];
                })
            },
            getBindAPP(){
                this.searchAppLoading = true;
                API.getBindApp({
                    search:this.formItem.search
                }).then(res=>{
                    console.log('getBindApp',res);
                    let resData = res.data||{};
                    let appList = resData.list||[];
                    let isInList = [];
                    appList.forEach(app=>{
                        let appItem = this.checkedAppList.find(item=>item.plat_id==app.plat_id&&item.subitem_id===app.subitem_id);
                        if(!appItem){
                            this.checkedAppList.push({...app});
                        }else{
                            isInList.push(app);
                        }
                    });
                    // if(isInList.length>0){
                    //     this.$message.success('以下app已存在：'+isInList.map(item=>`【${item.plat_name}】${item.app_name||'--'}（${item.subitem_id}）`).join(','));
                    // }


                    let unFoundApps = resData.unfound_apps||[];
                    if(unFoundApps.length>0){
                        let htmlStr = `<div style="max-height: 150px;overflow: auto;">`;
                        htmlStr += '<p>未找到以下产品，请检查ID或包名是否输入准确，并且非新产品：</p>';
                        htmlStr += '<p class="font12px">'+(unFoundApps.join('、'))+`</p></div>`;
                        this.$alert(htmlStr, '提示', {
                            confirmButtonText: '知道了',
                            dangerouslyUseHTMLString: true,
                            type: 'error',
                        });
                    }else{
                        this.formItem.search = '';
                    }
                    this.searchAppLoading = false;
                },err=>{
                    console.log('getBindApp err',err);
                    this.$message.error(err.info||'请求失败');
                    this.searchAppLoading = false;
                })
            },

        }
    }
</script>

<style lang="scss" scoped>
    ::v-deep .el-dialog__body{
        padding: 10px 30px 20px;
    }

    ::v-deep .word-limit-input input{
        padding-right: 80px;
    }

    .app-list{
        min-height: 100px;
        max-height: 300px;
        border: dashed 1px #ccc;
        /*padding: 10px;*/
        display: flex;
        flex-wrap: wrap;
        /*justify-content: ;*/
        padding-top: 10px;
        overflow-y: auto;

        .app-item{
            border: solid 1px #ccc;
            width: 235px;
            height: 66px;
            max-height: 300px;
            flex-shrink: 0;
            margin:0 10px 10px 0;
            padding:5px 24px 5px 5px;
            border-radius: 8px;
            background-color: #c9e9f7;
            &>p{
                line-height: 18px;
                font-size: 12px;
            }
            .close-btn{
                position: absolute;
                right: 0;
                top: 0;
                width: 24px;
                height: 72px;
                line-height: 70px;
                background-color: #ec808d;
                text-align: center;
                cursor: pointer;
                color: #fff;
            }
        }
    }
</style>
